import React from "react";
import { useTranslation } from "react-i18next";
import BrandNav from "../components/BrandNav";

export default function Showcase() {
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("showcase.title")}</h1>
        <p>{t("showcase.subtitle")}</p>
      </main>
    </>
  );
}
